import React from 'react';

import ScheduleApi from '../../api-services/ScheduleApi';

import ScheduleMain from '../../schedules/ScheduleMain';

import OfferSelectColumnManager from './OfferSelectColumnManager';
import OfferSelectDataModel from './OfferSelectDataModel';
import OfferSelectSummaryDataModel from './OfferSelectSummaryDataModel';
import OfferSelectSummaryView from './OfferSelectSummaryView';

export class OfferSelectMain extends ScheduleMain {
    constructor(props) {
        super(props);

        this.summaryDataModel = new OfferSelectSummaryDataModel(this.counterparty.preferenceGroupName);

        this.dataModel = new OfferSelectDataModel(
            this.locale,
            this.counterparty,
            this.commandDataModel,
            this.summaryDataModel,
            this.props.counterparty.parameters.PriceDefaultValue
        );

        this.columnManager = new OfferSelectColumnManager(
            this.session,
            this.counterparty,
            this.props.counterparty.parameters.PriceCurrency
        );

        this.columnManager.settings.loadColumnSettings();
    }

    componentDidMount() {
        super.componentDidMount();
    }
    
    componentWillUnmount() {
        this.summaryDataModel.dispose();

        super.componentWillUnmount();
    }

    renderUsageSummaries() {
        return (
            <OfferSelectSummaryView
                dataModel={this.summaryDataModel}
                locale={this.locale}
            />
        );
    }

    async loadGridValues() {
        this.closePopOutEditor();

        var scheduleUpdateDto = await ScheduleApi.getFullUpdate(
            this.counterparty.code,
            this.commandDataModel.currentMonth
        );

        this.dataModel.processFullServerUpdate(scheduleUpdateDto);

        this.commandDataModel.updateProperties({
            isEditingEnabled: this.dataModel.isEditingEnabled,
            canUserManageColumnPreferences: scheduleUpdateDto.canUserManageColumnPreferences && scheduleUpdateDto.allowToggleElection,
            currentContracts: this.dataModel.contracts,
            resubmitContracts: this.dataModel.contracts.filter(contract => contract.enableResubmitValues)
        });
    }

    async updateGridValues(lastRetrievalTimeUtc) {
        var scheduleUpdateDto = await ScheduleApi.getPartialUpdate(
            this.counterparty.code,
            this.commandDataModel.currentMonth,
            lastRetrievalTimeUtc
        );

        this.dataModel.processBackgroundServerUpdate(scheduleUpdateDto);
    }

    submitGridChanges(onSubmitFinished) {
        this.closePopOutEditor();

        var dateSubmissions = this.dataModel.getCurrentModifications();
        ScheduleApi.submitChanges(
            this.counterparty.code,
            dateSubmissions,
            onSubmitFinished,
            this.dataModel.summaryDataModel.isNotifyEnabled
        );
    }

    revertGridChanges() {
        this.closePopOutEditor();
        this.dataModel.revertCurrentModifications();
    }

    onViewKeyDown(event) {
        super.onViewKeyDown(event);

        if (event.key === 'Escape') {
            this.closePopOutEditor();
        }
    }

    onDataGridEditingStart(event) {
        super.onDataGridEditingStart(event);
    }

    onDataGridKeyDown(event) {
        if (event.event.code === 'Escape') {
            this.closePopOutEditor();
        }
    }

    onDataGridContextMenuPreparing(event) {
        if (event.target !== 'content')
            return;

        var disabled = true;

        if (disabled) {
            event.items = [];
            return;
        }

        event.items = [];
    }
}
